export default "__VITE_ASSET__BhdXCF9C__"